import { render, staticRenderFns } from "./UserWalletTransactions.vue?vue&type=template&id=14481c4f&scoped=true"
import script from "./UserWalletTransactions.vue?vue&type=script&lang=js"
export * from "./UserWalletTransactions.vue?vue&type=script&lang=js"
import style0 from "./UserWalletTransactions.vue?vue&type=style&index=0&id=14481c4f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14481c4f",
  null
  
)

export default component.exports